import { Chip, CircularProgress } from '@mui/material';
import { useActiveCapTableGeneration } from './useActiveCapTableGeneration';

/**
 * Lightweight chip shown on the cap table page while an AI cap-table generation
 * job is in progress, so the status is visible without opening the drawer.
 * Renders nothing when no generation job is active.
 */
const GenerationInProgressIndicator = () => {
  const { isGenerating, documentCount } = useActiveCapTableGeneration();

  if (!isGenerating) {
    return null;
  }

  const label = documentCount
    ? `Extracting cap table from ${documentCount} document${documentCount > 1 ? 's' : ''}...`
    : 'Extracting cap table...';

  return (
    <Chip
      size="small"
      color="info"
      variant="outlined"
      data-testid="cap-table-generation-in-progress"
      icon={<CircularProgress size={14} color="inherit" />}
      label={label}
    />
  );
};

export default GenerationInProgressIndicator;
